<template>
    <div class="family">
      <div>
        <el-button type="primary" plain icon="el-icon-plus" @click="addHomePerson()">新增成员</el-button>
      </div>
      <div style="margin-top: 10px;height: 405px">
      <el-table
        :data="showTable"
        border
        style="width: 100%"
        highlight-current-row
        ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="50">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          min-width="80">
        </el-table-column>
        <el-table-column
          prop="phone"
          label="联系方式"
          min-width="85">
        </el-table-column>
        <el-table-column
          prop="createtime"
          label="创建时间"
          min-width="110">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          min-width="85">
        </el-table-column>
        <el-table-column align="center" label="操作" min-width="90"  class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <i class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="editHomePerson(scope.row)"></i>
            <i class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="delHomePerson(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px;margin-bottom:10px;text-align: center">
        <el-pagination v-fixZoom
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
      </div>
      <div style="text-align: right">
        <el-button @click="closeBack()">取消</el-button>
      </div>
      <el-dialog width="600px" title="新增家庭成员" :visible.sync="familyAddEdit" append-to-body>
        <el-form style="margin-right: 25px" :model="addFamilyForm" :rules="addFamilyRules" ref="addFamilyForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="成员姓名" prop="name">
            <el-input v-model="addFamilyForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="name">
            <el-input type="number" v-model="addFamilyForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="小程序账号" prop="">
            <el-radio-group v-model="addFamilyForm.is_open_applet">
              <el-radio :label="0">不开通</el-radio>
              <el-radio :label="1">开通</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入关系备注" v-model="addFamilyForm.remark"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: center">
          <el-button @click="closeFamily()">取 消</el-button>
          <el-button type="primary" @click="submitAddEdit('addFamilyForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
</template>

<script>
import {queryfamilyperson, addfamilyperson, updatefamilyperson, deletefamilyperson} from '../../../api/serviceObject'

export default {
  name: 'seeFamily',
  model: {
    prop: 'familyShow',
    event: 'change'
  },
  props: {
    familyData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tableData: [],
      showTable: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      familyAddEdit: false,
      addFamilyForm: {
        id: 0,
        name: '',
        phone: '',
        remark: '',
        personid: '',
        is_open_applet: 0
      },
      addFamilyRules: {
        name: [
          { required: true, message: '请输入成员姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系方式', trigger: 'blur' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.getFamilyData()
    this.addFamilyForm.personid = this.familyData.row.id
  },
  mounted () {
  },
  methods: {
    getFamilyData () {
      let orgid = this.$store.state.user.orgid
      let personid = [this.familyData.row.id]
      let data = {
        orgid: orgid,
        personid: personid
      }
      queryfamilyperson(data).then(res => {
        this.tableData = res.data.familypersons
        this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
        this.totalCells = this.tableData.length
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    // 添加
    addHomePerson () {
      this.addFamilyForm = {
        id: 0,
        name: '',
        phone: '',
        remark: '',
        personid: this.familyData.row.id
      }
      this.familyAddEdit = true
    },
    closeFamily () {
      this.addFamilyForm = {
        id: 0,
        name: '',
        phone: '',
        remark: '',
        personid: this.familyData.row.id,
        is_open_applet: 0
      }
      this.familyAddEdit = false
    },
    // 编辑
    editHomePerson (row) {
      this.addFamilyForm.id = row.id
      this.addFamilyForm.name = row.name
      this.addFamilyForm.phone = row.phone
      this.addFamilyForm.remark = row.remark
      this.addFamilyForm.personid = this.familyData.row.id
      this.is_open_applet = row.is_open_applet
      this.familyAddEdit = true
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.addFamilyForm.id === 0) {
            addfamilyperson(this.addFamilyForm).then(res => {
              this.$notify({ title: '成功', message: '成功新建家庭成员', type: 'success', duration: 2000 })
              this.getFamilyData()
              this.familyAddEdit = false
            }).catch(() => {})
          } else {
            updatefamilyperson(this.addFamilyForm).then(res => {
              this.$notify({ title: '成功', message: '成功编辑家庭成员', type: 'success', duration: 2000 })
              this.getFamilyData()
              this.familyAddEdit = false
            }).catch(() => {})
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 删除家庭成员
    delHomePerson (row) {
      let name = row.name
      this.$confirm('此操作将永久删除该家庭成员【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        let data = {
          personids: [row.id]
        }
        deletefamilyperson(data).then(res => {
          this.$notify({ title: '成功', message: '删除该家庭成员成功', type: 'success', duration: 2000 })
          this.getFamilyData()
        }).catch(() => {})
      }).catch(() => {})
    },
    closeBack () {
      this.$emit('change', false)
    }
  }
}
</script>

<style scoped>
.family{
  width: 100%;
  height: 500px;
  overflow-y: auto;
  /*background-color: #42b983;*/
}
</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/seeFamily.vue